import React from 'react';
import MembersComponent from '../components/MembersPage';

function MembersPage() {
  return (
    <MembersComponent/>
  );
}

export default MembersPage;